import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  Input
} from '@angular/core';
import { appState } from '@services/app-state';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { OnInit } from '@angular/core';

import { AuthService } from '@noammazuz/vzn-feathers';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy, OnInit {
  mobileQuery: MediaQueryList;
  @Input() inputSideNav: MatSidenav;

  private _mobileQueryListener: () => void;
  appState = appState;
  constructor(
    public authService: AuthService<any>,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
  ) {
    // debugger;
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }
  async ngOnInit() {
    this.appState.user = await this.authService.getAuthUser();

  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  logout() {
    this.authService.logout()
  }
}
